import React from 'react';
import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { KeyRound, LogOut, ChevronUp, ChevronDown } from 'lucide-react';

const UserProfile = ({ username, email, onLogout, onResetPassword }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className="border-t border-gray-200">
      <div
        className="p-4 hover:bg-gray-50 cursor-pointer"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <div className="flex items-start justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold">
              {username.charAt(0)}
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-900">{username}</h3>
              <p className="text-xs text-gray-500">{email}</p>
            </div>
          </div>
          {isDropdownOpen ? <ChevronUp className="w-5 h-5 text-gray-500" /> : <ChevronDown className="w-5 h-5 text-gray-500" />}
        </div>
        {isDropdownOpen && (
          <div className="mt-2 py-1 border-t border-gray-100">
            <button onClick={onResetPassword} className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100">
              <KeyRound className="w-4 h-4 mr-2" /> Reset Password
            </button>
            <button onClick={onLogout} className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100">
              <LogOut className="w-4 h-4 mr-2" /> Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const Sidebar = ({ isOpen, toggleSidebar }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredItems, setFilteredItems] = useState([]);
    const [user, setUser] = useState({ username: "John Doe", email: "john.doe@example.com" });
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const navigate = useNavigate();
    const sidebarRef = useRef(null);
    // Auth0 Management API configuration
    const config = {
        domain: "optimus-cuhk.us.auth0.com",
        clientId: "LKZrxD6TiCnbL637KKfIsP0qR2b2t1gs",
        audience: "https://optimus-cuhk.us.auth0.com/api/v2/"
    };

    // Fetch access token function
    const getAccessToken = async () => {
    try {
        const response = await fetch(`https://${config.domain}/oauth/token`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                client_id: config.clientId,
                client_secret: "FmQer9_XzWqzqAKT1hi8tlv9gdpoOfZLtqcmb90LU5hQ9poboGP_h5AnxfcTkiNQ",
                audience: config.audience,
                grant_type: "client_credentials",
                scope: "read:users read:users_app_metadata update:users_app_metadata read:user_idp_tokens read:client_grants create:users update:users delete:users read:clients read:client_credentials create:client_credentials read:roles update:roles create:roles"
            })
        });
        
        if (!response.ok) {
            throw new Error(`Token request failed: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (!data.access_token) {
            throw new Error('No access token in response');
        }
        
        return data.access_token;
    } catch (error) {
        console.error('Error getting access token:', error);
        return null;
    }
};

    // Fetch user data from Auth0
    useEffect(() => {
        const fetchCurrentUser = async () => {
    try {
        const token = await getAccessToken();
        
        if (!token) {
            console.error('No access token available');
            return;
        }
        
        const response = await fetch(`${config.audience}users`, {
            headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
            const data = await response.json();
            const storedUser = JSON.parse(localStorage.getItem("user"));

            const auth0User = data.find(u => u.email === storedUser?.email);

            if (auth0User) {
                const userData = {
                    username: auth0User.user_metadata?.username || auth0User.username || auth0User.name || auth0User.nickname || auth0User.email.split('@')[0],
                    email: auth0User.email,
                    role: auth0User.app_metadata?.role || "User",
                };

                setUser(userData);
                localStorage.setItem("user", JSON.stringify(userData));
            }
        } else {
            console.error("Failed to fetch users:", await response.text());
        }
    } catch (error) {
        console.error("Error fetching users:", error);
    }
};

        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (storedUser) {
            setUser(storedUser);
            fetchCurrentUser(); // Fetch fresh data from Auth0
        }
    }, []);
    
    // Define menu items with their routes and icons
    const menuItems = [
        {
            name: "Dashboard",
            path: "/dashboard",
            icon: (
                <div className="w-6 h-6 mr-3">
                    <img src='./dash.png' width={24} height={24} alt="Dashboard" />
                </div>
            )
        },

        {
            name: "Desks",
            path: "/desks",
            icon: (
                <div className="w-6 h-6 mr-3">
                    <img src='./desks.png' width={26} height={26} alt="Desks" />
                </div>
            )
        },

        {
            name: "Historical Data",
            path: "/historical-data",
            icon: (
                <div className="w-6 h-6 mr-3">
                    <img src='./time.png' width={26} height={26} alt="data" />
                </div>
            )
        },
        
        {
            name: "Manage Devices",
            path: "/device-management",
            icon: (
                <div className="w-6 h-6 mr-3">
                     <img src='./device.png' width={26} height={26} alt="devices" />
                </div>
            )
        },
    ];

    // Filter menu items based on search query
    useEffect(() => {
        if (searchQuery.trim() === "") {
            setFilteredItems(menuItems);
        } else {
            const filtered = menuItems.filter(item => 
                item.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredItems(filtered);
        }
    }, [searchQuery]);

    // Initialize filteredItems with all menu items on component mount
    useEffect(() => {
        setFilteredItems(menuItems);
    }, []);

    

    // Handle "Cmd + K" to focus the search bar
    useEffect(() => {
        const handleKeyDown = (event) => {
            if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
                event.preventDefault();
                document.getElementById("search-bar").focus();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    

    // Logout function
    const handleLogout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("access_token");
        setUser({ username: "John Doe", email: "john.doe@example.com" });
        // You could redirect to login page here if using React Router
        navigate("/login", { replace: true });
    };

    // Reset password function
    const handleResetPassword = async () => {
        try {
            const response = await fetch("https://optimus-cuhk.us.auth0.com/dbconnections/change_password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    client_id: "LKZrxD6TiCnbL637KKfIsP0qR2b2t1gs",
                    email: user.email,
                    connection: "Username-Password-Authentication",
                }),
            });

            if (response.ok) {
                setIsOverlayOpen(true);
                setTimeout(() => setIsOverlayOpen(false), 3000);
            } else {
                const errorData = await response.json();
                alert(errorData.error_description || "Failed to send reset email.");
            }
        } catch (error) {
            console.error("Error sending password reset email:", error);
            alert("Something went wrong. Please try again.");
        }
    };

    // Close sidebar if clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target) && isOpen) {
                toggleSidebar();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, toggleSidebar]);

    return (
        <>
            {/* Overlay for clicking outside to close sidebar */}
            {isOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-20" 
                    onClick={toggleSidebar}
                ></div>
            )}
            
            {/* Sidebar */}
            <div 
                ref={sidebarRef}
                className={`h-screen bg-white shadow-md w-80 fixed left-0 top-0 z-30 transition-transform duration-300 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} flex flex-col`}
            >
                <div className="pt-6 pb-3 px-6 flex justify-between items-center">
                    <div className="flex items-center">
                        <div className="w-9 h-9 mr-2">
                            <img src='/op.png' alt="Optimus Logo" />
                        </div>
                        <h1 className="text-2xl font-bold">Optimus</h1>
                    </div>
                    
                    {/* Close button */}
                    <button onClick={toggleSidebar} className="text-gray-600 hover:text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="relative p-4">
                    <input
                        id="search-bar"
                        type="text"
                        placeholder="Search"
                        className="w-[96%] pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <span className="absolute left-7 top-1/2 transform -translate-y-1/2 text-gray-400">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0,0,256,256">
                            <g fill="#4d4d4d" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none">
                                <g transform="scale(8.53333,8.53333)">
                                    <path d="M13,3c-5.511,0 -10,4.489 -10,10c0,5.511 4.489,10 10,10c2.39651,0 4.59738,-0.85101 6.32227,-2.26367l5.9707,5.9707c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-5.9707,-5.9707c1.41266,-1.72488 2.26367,-3.92576 2.26367,-6.32227c0,-5.511 -4.489,-10 -10,-10zM13,5c4.43012,0 8,3.56988 8,8c0,4.43012 -3.56988,8 -8,8c-4.43012,0 -8,-3.56988 -8,-8c0,-4.43012 3.56988,-8 8,-8z"></path>
                                </g>
                            </g>
                        </svg>
                    </span>
                    <span className="absolute right-[68px] top-1/2 transform -translate-y-1/2 bg-[#d1d1d157] text-gray-700 text-xs font-semibold px-2 py-1 rounded">
                        ⌘ 
                    </span>
                    <span className="absolute right-10 top-1/2 transform -translate-y-1/2 bg-[#d1d1d157] text-gray-700 font-medium text-xs px-2 py-1 rounded">
                        K
                    </span>
                </div>
                
                <div className="flex-grow mt-4 overflow-y-auto">
                    <nav className="flex flex-col space-y-4 px-4">
                        {filteredItems.length > 0 ? (
                            filteredItems.map((item, index) => (
                                <Link 
                                    key={index} 
                                    to={item.path} 
                                    className={`flex items-center p-2 ${item.disabled ? "cursor-not-allowed text-gray-400" : "hover:bg-gray-100 rounded-md"}`}
                                    onClick={item.disabled ? (e) => e.preventDefault() : null} // Prevent the click action if disabled
                                >
                                    {item.icon}
                                    <span className={item.disabled ? "text-gray-400" : "text-gray-700"}>{item.name}</span>
                                </Link>
                            ))
                        ) : (
                            <div className="text-center py-4 text-gray-500">
                                No results found
                            </div>
                        )}
                    </nav>
                </div>
                
                {/* User Profile Section (Added from second implementation) */}
                <div className="mt-auto">
                    <UserProfile 
                        username={user.username}
                        email={user.email}
                        onLogout={handleLogout}
                        onResetPassword={handleResetPassword}
                    />
                </div>

                {/* Password Reset Overlay */}
                {isOverlayOpen && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                        <div className="bg-white p-4 rounded-lg shadow-lg text-center w-64">
                            <h2 className="text-[16px] font-semibold text-gray-900">Password Reset Sent</h2>
                            <p className="text-gray-600 text-sm mt-2">
                                A reset link has been sent to <strong>{user.email}</strong>. Please check your inbox.
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Sidebar;